module.exports = __webpack_public_path__ + "img/report.f12d9d1c.jpg";